const heroStats = [
  { value: '2,600+', label: '海量国漫' },
  { value: '4.9', label: '用户评分' },
  { value: '1,200w+', label: '移动端读者' },
];

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[600px] w-full items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=vibrant%20manga%20comic%20hero%20banner%20illustration%20with%20dynamic%20cartoon%20characters%20leaping%20through%20colorful%20splashes%20of%20warm%20orange%20gold%20and%20cream%2C%20playful%20energetic%20flat%20art%2C%20stylized%20entertainment%20backdrop%2C%20no%20text&width=1600&height=1000&seq=hero-comic-bg&orientation=landscape"
        alt="咪咕漫画网移动端阅读平台主视觉"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/55 to-foreground-950/25" />

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-start px-4 py-24 md:px-6 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-4 py-1.5 text-xs font-bold text-foreground-950">
          <i className="ri-smartphone-line text-sm" />
          专为移动端优化 · 手机版阅读
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          咪咕漫画网手机版
          <span className="block text-accent-300">随时翻页 · 快乐追更</span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          咪咕漫画网手机版专为移动端阅读优化，覆盖安卓版与 iOS 版客户端。点开即得移动端入口，随时随地流畅翻页，收藏追更两不误，通勤路上也能轻松看漫画。
        </p>

        <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
          <a
            href="#download"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-android-fill text-lg" />
            安卓版下载
          </a>
          <a
            href="#download"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-600"
          >
            <i className="ri-apple-fill text-lg" />
            iOS 版下载
          </a>
          <a
            href="#featured"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/60 bg-background-50/10 px-6 py-3 text-sm font-bold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
          >
            开始阅读
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <dl className="mt-12 flex flex-wrap gap-6 md:gap-10">
          {heroStats.map((s) => (
            <div key={s.label} className="border-l-2 border-accent-500/70 pl-4">
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-heading text-2xl text-background-50 md:text-3xl">{s.value}</dd>
              <dd className="mt-1 text-xs text-background-200 md:text-sm">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}